import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M1.293 1.293a1 1 0 0 1 1.414 0l8.161 8.161.023.023 11.816 11.816a1 1 0 1 1-1.414 1.414l-5.373-5.373a1 1 0 0 1-1.12-.19 4 4 0 0 0-5.6 0 1 1 0 0 1-1.4-1.43 6 6 0 0 1 4.818-1.682l-2.77-2.77A9 9 0 0 0 5.7 13.574a1 1 0 0 1-1.4-1.428A11 11 0 0 1 8.247 9.66L5.958 7.372a14 14 0 0 0-3.291 2.193 1 1 0 0 1-1.334-1.49 16 16 0 0 1 3.138-2.19L1.293 2.707a1 1 0 0 1 0-1.414M12.01 19a1 1 0 0 1 0 2H12a1 1 0 1 1 0-2zm4.117-8.163a1 1 0 0 1 1.365-.367 11 11 0 0 1 2.208 1.675 1 1 0 0 1-1.4 1.428 9 9 0 0 0-1.807-1.37 1 1 0 0 1-.366-1.366M10.626 4.06a16 16 0 0 1 12.041 4.014 1 1 0 0 1-1.334 1.491 14 14 0 0 0-10.535-3.513 1 1 0 1 1-.172-1.992" }, null, -1)
  ]))]))
}
export default { render: render }